/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequiredStringResource
 */
export interface RequiredStringResource {
    /**
     * 
     * @type {string}
     * @memberof RequiredStringResource
     */
    value: string;
}

/**
 * Check if a given object implements the RequiredStringResource interface.
 */
export function instanceOfRequiredStringResource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function RequiredStringResourceFromJSON(json: any): RequiredStringResource {
    return RequiredStringResourceFromJSONTyped(json, false);
}

export function RequiredStringResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequiredStringResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function RequiredStringResourceToJSON(value?: RequiredStringResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

